import { Box, Stack } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { HeaderBar } from '../../components/header/header-bar';
import { SideMenu } from '../../components/side-menu/side-menu';
import { Routing } from '../../routes';
import { PostAuthenticatedRoutes } from '../../routes/post-authenticated-routes';
import { RootState } from '../../store';
import { updateRefetchApiCall } from '../../store/reducers/apiCallSlice';
import { NavigationConfig } from '../../utils/navigation-constants';
import { LandingPageStyle } from './landing-page-style';

const LandingPage: React.FC = () => {
    const { isLoggedIn } = useSelector((state: RootState) => state.user);
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const location = useLocation(); // Get the current route
    const showAddIcon =
        location.pathname === NavigationConfig.ManageWorkOrder ||
        location.pathname === NavigationConfig.ManageAdmin ||
        location.pathname === NavigationConfig.ManageInstaller ||
        location.pathname === NavigationConfig.ManageCustomer;

    const handleAddFromHeader = () => {
        if (window.handleAddWorkOrder) {
            window.handleAddWorkOrder();
        } else if (window.handleAddInstaller) {
            window.handleAddInstaller();
        } else if (window.handleAddAdmin) {
            window.handleAddAdmin();
        } else if (window.handleAddCustomer) {
            window.handleAddCustomer();
        }
    };
    useEffect(() => {
        if (!location.pathname.includes(NavigationConfig.ManageCustomer)) {
            dispatch(
                updateRefetchApiCall({
                    page: 1,
                }),
            );
        }
    }, [dispatch, location.pathname]);

    return (
        <Stack>
            {isLoggedIn ? (
                <LandingPageStyle>
                    <SideMenu menuOpen={open} menuClose={() => setOpen(false)} />
                    <Box className="body-content">
                        <HeaderBar
                            openMenuClick={() => setOpen(true)}
                            showIcon={showAddIcon}
                            onAddClick={handleAddFromHeader}
                        />
                        <PostAuthenticatedRoutes />
                    </Box>
                </LandingPageStyle>
            ) : (
                <Routing />
            )}
        </Stack>
    );
};

export { LandingPage };
